import React from 'react';
import PropTypes from 'prop-types';
import {Paper} from "material-ui";
import Subheader from 'material-ui/Subheader';
import {connect} from "react-redux";
import Error from "../../../components/common/Error/Error";
import Loading from "../../../components/common/Loading/Loading";
import {fetchApp} from '../../../store/apps/actions';
import style from '../../../styles/styles';
import styles from './AddTrailPage.css';
import {postTrail} from "../../../store/trails/actions";
import TrailForm from "../../../components/openexplore/TrailForm/TrailForm";
import {getCustomFields} from "../../../store/customfields/actions";
import {getTypes} from "../../../store/types/actions";
import CustomFieldService from '../../../services/customfield';
import {dispatchInfo} from "../../../store/infos/actions";
import {TRAIL_PAGE} from "../../../constants/routes";

export class AddTrailPage extends React.Component {

    static propTypes = {
        app: PropTypes.object
    };

    static defaultProps = {};

    state = {
        shouldCreateNew: false
    };

    componentWillMount() {
        this.fetchApplication();

        if (this.props.app) {
            this.props.getTypes(this.props.app.id, this.props.lang);
            this.props.getCustomFields(this.props.app.id);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.app && this.props.app !== nextProps.app) {
            this.props.getTypes(nextProps.app.id, nextProps.lang);
            this.props.getCustomFields(nextProps.app.id);
        }
    }

    componentWillUpdate(nextProps) {
        if (this.props.sending && !nextProps.sending && nextProps.trail) {

            if (this.state.shouldCreateNew) {
                this.props.dispatchInfo(nextProps.trail.name + ' saved');
            }

            if (!this.state.shouldCreateNew) {
                let url = TRAIL_PAGE
                    .replace(':appId', this.props.app.id)
                    .replace(':trailId', nextProps.trail.id);
                this.props.history.push(url);
            }

        }

        if (this.state.shouldCreateNew) {
            this.setState({ shouldCreateNew: false });
        }
    }

    // Actions

    handleFormSubmit = async (formProps) => {
        await this.props.postTrail(this.props.app.id, formProps, this.props.lang);
    };

    handleFormReset = () => {
        this.setState({ shouldCreateNew: true });
    };

    // Fetch

    fetchApplication(appId = null) {
        if (this.props.match) {
            const id = appId || this.props.match.params.appId;

            if (id) {
                this.props.fetchApp(id)
            }
        }
    }

    // Render

    render() {
        if (this.props.error) {
            return (
                <Error
                    title="Error"
                    subtitle="Could not load data"
                    paper={true}
                />
            );
        } else if (this.props.loading || !this.props.app) {
            return <Loading paper={false}/>;
        } else {
            return (
                <div>
                    <h3 style={style.navigation}>Trail / Add - {this.props.app.name}</h3>
                    <div className="row">
                        <div style={style.col} className="col-xs-12 col-sm-12 col-md-12">
                            <Paper style={styles.editBox}>
                                <Subheader style={style.subHeader}>New trail</Subheader>

                                <div style={style.paper}>
                                    <TrailForm
                                        customFields={CustomFieldService.filter(this.props.customFields, CustomFieldService.OPEN_EXPLORE_TRAIL)}
                                        types={this.props.types}
                                        onSubmit={this.handleFormSubmit}
                                        onFormReset={ this.handleFormReset }
                                        submitting={this.props.sending}
                                    />
                                </div>
                                <div style={style.clear}/>
                            </Paper>
                        </div>
                    </div>
                </div>
            )
        }
    }
}

function mapStateToProps(state, ownProps) {
    return {
        loading: state.apps.pending || state.trails.pending || state.types.pending || state.customFields.pending,
        error: state.apps.error,
        trail: state.trails.currentTrail,
        lang: state.ui.currentLang,
        app: state.apps.currentApplication,
        sending: state.trails.sending,
        mapStyle: state.ui.mapStyle,
        types: state.types.content,
        customFields: state.customFields.content
    };
}

export default connect(mapStateToProps, {
    getTypes,
    getCustomFields,
    postTrail,
    fetchApp,
    dispatchInfo
})(AddTrailPage);



// WEBPACK FOOTER //
// src/containers/openexplore/AddTrailPage/AddTrailPage.js